export default "__VITE_PUBLIC_ASSET__ee5b378f__"